import { jsPDF } from 'jspdf';
import {
  addBorderedTable,
  addBorderlessTable,
  addDistEsq,
  addDocsNec,
  addEntsComp,
  addFonts,
  addIdImovelSection,
  addImovelImg,
  addLegendaSection,
  addLogo,
  addMainSubtitle,
  addMainTitle,
  addMapaSection,
  addObsImportantes,
  addPageBorders,
  addReduzidoBox,
  MapLegendData,
} from './fns';

export interface PDFData {
  reduzido: string;
  inscMob: string;
  prop: string;
  loteamento: string;
  quadra: string;
  lote: string;
  areaTerreno: string;
  testada: string;
  areaConstruida: string;
  logradouro: string;
  numero: string;
  distEsq: string;
  mapImgURL: string;
  imovelImg?: string;
  rua: {
    nome: string;
    sisViar: string;
    caixa: string;
    pista: string;
    passeio: string;
    cantCentral: string;
  };
  zona: {
    tipo_uso: string;
    tipo_comp: string;
    indice_apr: string;
    taxa_ocupa: string;
    num_pav: string;
    recuo_f_r: string;
    recuo_f_c: string;
    recuo_lat: string;
    recuo_fun: string;
    ind_apr_ba: string;
    num_pav_c: string;
    ind_apr_ma: string;
    recuo_f_e: string;
    recuo_f_i: string;
    taxa_perme: string;
  };
  mapLegend: MapLegendData;
  docs: {
    isWithinPreamar: boolean;
    isWithinAPP: boolean;
  };
}

export function generatePDF(data: PDFData) {
  const doc = new jsPDF({
    unit: 'cm',
  });

  addFonts(doc);
  addLogo(doc);
  addMainTitle(doc);
  addMainSubtitle(doc);
  addReduzidoBox(doc, data.reduzido);
  addIdImovelSection(doc, {
    insc: data.inscMob,
    prop: data.prop,
    loteamento: data.loteamento,
    quadra: data.quadra,
    lote: data.lote,
    areaConstr: data.areaConstruida,
    logra: data.logradouro,
    num: data.numero,
    areaTerr: data.areaTerreno,
    testada: data.testada,
  });
  addImovelImg(doc, data.imovelImg);
  addMapaSection(doc, data.mapImgURL);
  addDistEsq(doc, data.distEsq);
  addLegendaSection(doc, data.mapLegend);
  addBorderlessTable(doc, {
    ruas: data.rua.nome,
    caixa: data.rua.caixa,
    cantCentral: data.rua.cantCentral,
    passeio: data.rua.passeio,
    pista: data.rua.pista,
    sisViar: data.rua.sisViar,
  });
  addBorderedTable(doc, data.zona);
  addObsImportantes(doc);
  addDocsNec(doc, data.docs);
  addEntsComp(doc);
  addPageBorders(doc);

  // const url = doc.output("bloburl");

  // document.getElementById("iframe")?.setAttribute("src", url);
  doc.save(`${data.reduzido}.pdf`);
}
